import {Component} from 'inferno';

import {subscribe} from '../../../replete';

@subscribe({
    auth: ['api.auth'],
})
class AuthedUrlWrapperInner extends Component<jsx.Props, jsx.State> {
    render() {
        const {url, childrenFunc} = this.props;
        // Since this class depends on api.auth data, it will refresh when
        // access_token is updated.
        return childrenFunc(this.context.apiService.addAuthToImgUrlIfV2(url));
    }
}

type ChildrenFunc = (url?: string) => any;

export function AuthedUrlWrapper(
    {url, childrenFunc}: {url?: string, childrenFunc: ChildrenFunc}) {
    if (url?.includes?.('/v2/')) {
        return <AuthedUrlWrapperInner url={url} childrenFunc={childrenFunc}/>;
    }
    return childrenFunc(url);
}
